/**
 * Normalizes a search query for de-duplication and `query_length` analytics.
 * trim -> collapse internal whitespace -> lowercase
 */
export function normalizeQuery(raw: string): string {
  return raw.trim().replace(/\s+/g, " ").toLowerCase();
}
